import { render, staticRenderFns } from "./signFreezerMsgStatistics.vue?vue&type=template&id=98605bb4&"
import script from "./signFreezerMsgStatistics.vue?vue&type=script&lang=js&"
export * from "./signFreezerMsgStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports